import { Injectable } from '@angular/core';
import { GET, POST, DELETE, PUT } from 'src/app/network/network.service';

@Injectable({
  providedIn: 'root'
})
export class BusBulkEnrollService {

  constructor() { }

  // 1. Import students to bus (file upload)
  @POST('v2/admin/schools/:schoolId/bus-import/upload')
  importStudentsToBus(body: any, pathParams?: any, headers?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 2. Validate uploaded students
  @POST('v2/admin/schools/:schoolId/bus-import/:batch_id/validate')
  validateUploadedStudents(body: any, pathParams?: any, headers?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 3. Get status
  @GET('v2/admin/schools/:schoolId/bus-import/:batch_id/status')
  getBatchStatus(queryParams: any, filterValues?: any, pathParams?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 4. History
  @GET('v2/admin/schools/:schoolId/bus-import/history')
  getImportHistory(queryParams: any, filterValues?: any, pathParams?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 5. Get failed records
  @GET('v2/admin/schools/:schoolId/bus-import/:batch_id/failed-records')
  getFailedRecords(queryParams: any, filterValues?: any, pathParams?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 6. Get available trips from bus
  @GET('v2/admin/schools/:schoolId/bus-import/available-trips-from-bus')
  getAvailableTripsFromBus(queryParams: any, filterValues?: any, pathParams?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 7. Ignore records
  @POST('v2/admin/schools/:schoolId/bus-import/:batch_id/ignore-records')
  ignoreRecords(body: any, pathParams?: any, headers?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 8. Update failed record
  @PUT('v2/admin/schools/:schoolId/bus-import/:batch_id/failed-records')
  updateFailedRecord(body: any, pathParams?: any, headers?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 9. Enroll students
  @POST('v2/admin/schools/:schoolId/bus-import/:batch_id/enroll')
  enrollValidatedStudents(body: any, pathParams?: any, headers?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 10. Get enrolled students
  @GET('v2/admin/schools/:schoolId/bus-import/:batch_id/get-enrolled-students')
  getEnrolledStudents(queryParams: any, filterValues?: any, pathParams?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

  // 11. Assign trips 
  @POST('v2/admin/schools/:schoolId/bus-import/trip-assignment/assign')
  assignTrips(body: any, pathParams?: any, headers?: any) {
    return undefined as any; // TypeScript requires a return statement
  }

}
